import React, { Fragment, useCallback } from 'react';
import { NoRecordsBanner } from '../OopsBanner';
import { UserContext } from '../Definitions/UserContext';
import { useTrackingEvent } from '../../Hooks/useAddTrackingEvent';
import { utils } from '../../utils/Utils';

export default function RenderBusinessFacilityInfo({ data, layout, siteData }: { data: any, layout: string, siteData: UserContext }) {

    const [TrackEvent] = useTrackingEvent();
    const IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    const isChip = layout === "2";

    const handleTrackEvent = useCallback(
        () => {
            if (!IsEditor && (siteData.isDormant || siteData.isDisplayHomeInVagaroPlus)) {
                let UserID = "VjyaDUqIaJ9ZTvKEP9kn6g==";
                let LoginDetails = utils.ReadCookie();
                let LoginUserID = LoginDetails.csEncUid;
                if (typeof LoginUserID != "undefined" && LoginUserID != null && LoginUserID != "") {
                    UserID = LoginUserID;
                }
                TrackEvent(
                    siteData.parentbid || "QX9p3jq6~mMP6js9ReeSqw==",
                    siteData?.staticencbid ?? "QX9p3jq6~mMP6js9ReeSqw==",
                    UserID,
                    3,
                    window.location.origin + "/" + window.location.pathname.split("/").find(val => val !== "") || "",
                    "",
                    () => { }
                );
            }
        },
        [TrackEvent, IsEditor, siteData],
    );

    if (!data || data.length == 0) {
        return <NoRecordsBanner message='Facility Information is not available.' />
    }

    const isStencil = data?.isStenciled === true;

    let mapList = []
    let country = "1";
    for (let key in data) {
        if(key=="Country") {
            country = data[key];
        }
        else {
            mapList.push({ key: key, value: data[key] });
        }
    }




    switch (layout) {
        default:
            return <DefaultLayout isChip={isChip} mapList={mapList} isStencil={isStencil} trackEventCall={handleTrackEvent} country={country} />
    }
}

    const endKeys = ["Appointment Cancellation Policy", "Special Instructions","Class Cancellation Policy"]


function DefaultLayout({ mapList, isStencil, trackEventCall, country,isChip }: {isChip: boolean, mapList: any, isStencil: boolean, trackEventCall: () => void, country: string }) {
    return <div className={isStencil ? "stenciled w-full" : " w-full "} style={{ display: "flex", justifyContent: "inherit", alignContent: "inherit", alignItems: "inherit", gap: "inherit", flexDirection: "inherit", flexWrap: "inherit" }}>
        {
            mapList.map((item: any, index: number) => {
                return < RenderFacilityKeyValuePair key={item.key} vkey={item.key} value={item.value} useChips={isChip} trackEventCall={trackEventCall} country={country} />
            })
        }
    </div>
}

const nonChipKeys = ["Phone","Website","Email","Appointment Cancellation Policy", "Special Instructions","Class Cancellation Policy"]

function RenderFacilityKeyValuePair({ vkey, value, trackEventCall, country, useChips }: { vkey: string, value: string, trackEventCall: () => void, country:string,useChips?:boolean }) {
    if (!value || value.length == 0)
        return null;
    if (vkey == "Website") {
        return null; // don't include website in facilty information since user is already on site (per Alec + Fred)
    }
    var WebsiteName = "";
    var Phoneno = "";

    if (vkey == "Phone") {
        Phoneno = value.replace("(", "").replace(")", "").replace(" ", "").replace(" ", "")
        if (utils.isNotEmptyOrWhiteSpace(Phoneno) && country == "2") {
            value = utils.formatUKPhoneNumber(Phoneno);
        }
    }

    const cls = (endKeys.includes(vkey)) ? "w-full" : "w-half full-width-mobile";
    return <div style={{ textAlign: "left", padding: "0 .75em .75em 0" }} className={'facility-item flex-column gap-small ' + cls + ' '+vkey.toLowerCase().replace(/ /g, "-")} onClick={() => { if (vkey == "Phone") { trackEventCall(); } }}>
        <h4 className='facility-title'><strong>{vkey}</strong></h4>
        {vkey == "Phone" ?
        <a className="vp-2  inherit-color fac-desc"  href={"tel:"+Phoneno}>{value}</a>  :
        vkey == "Website" ? <a href={value} target='_blank' rel="noreferrer" className="vp-2 inherit-color fac-desc"><u>{WebsiteName}</u></a> : vkey == "Phone" ?
        <a target='_blank' rel="noreferrer" href={`tel:${value.replace(/\D/g, '')}`} className="vp-2  inherit-color" >{value}</a> :

        useChips && !nonChipKeys.includes(vkey) ? <RenderAsChips vkey={vkey} value={value} /> :
        <div className="vp-2 fac-desc" dangerouslySetInnerHTML={{__html:value}}></div>}
    </div>

}

function RenderAsChips({ vkey, value }: { vkey: string, value: string }) {

    if(!vkey || !value || value.length==0 || typeof value !== "string")
        return null;

    let split = value.split(",").map((item) => item.trim()).filter((item) => item.length>0);

    if(!split || split.length==0)
        return null;


    return <div className='flex-row gap-small flex-wrap w-full fac-chip-row'>
        {split.map((item, index) => (
            <div key={index} className='fac-chip' style={{padding:".25em .5em", color:"var(--theme-color-6)", backgroundColor:"var(--theme-color-2)",borderRadius:"6px"}}>
                {item}
            </div>
        ))}
    </div>

}